<template lang="html">
  <div
    class="weather-forecast">
    <WeatherForecastBackground
      v-if="currentDay"
      :code="backgroundCode"
      :time="currentDay.time">
      <h3 class="city">{{ city }}</h3>
      <f7-swiper
        v-if="forecast.length"
        ref="forecastSwiper"
        pagination
         class="weather-forecast-swiper">
        <f7-swiper-slide
          v-for="(day, i) in days"
          :key="day.day"
          class="weather-forecast-slide">
          <WeatherForecastSlide
            :index="i"
            :day="day" />
        </f7-swiper-slide>
      </f7-swiper>
    </WeatherForecastBackground>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getForecast } from './service'
import { openweatherImage } from './service/utils'
import WeatherForecastBackground from './WeatherForecastBackground'
import WeatherForecastSlide from './WeatherForecastSlide'
export default {
  name: 'WeatherForecast',
  components: {
    WeatherForecastBackground,
    WeatherForecastSlide
  },
  data () {
    return {
      ts: 100000,
      slide: 0,
      city: '',
      forecast: [],
      mask: true
    }
  },
  computed: {
    ...mapGetters({
      weather: 'map/weather'
    }),
    daily () {
      return this.forecast.reduce((days, d) => {
        if (!days[d.day]) days[d.day] = []
        days[d.day].push(d)
        return days
      }, {})
    },
    days () {
      return Object.keys(this.daily).map(d => {
        const day = this.d(d, 'LLLL').replace(' 00:00', '')
        const code = this.reduceAndSort(this.daily[d], 'code')
        const image = openweatherImage(code)
        const forecast = this.daily[d]
        const time = forecast[0].today ? forecast[0].date : forecast[Math.ceil((forecast.length / 2) - 1)].date
        return { day, image, time, forecast }
      })
    },
    currentDay () {
      return this.days[this.slide] ? this.days[this.slide] : null
    },
    backgroundCode () {
      return this.slide === 0 ? this.weather.image : this.currentDay.image
    }
  },
  methods: {
    getSliderIndex () {
      this.slide = this.$refs.forecastSwiper.swiper.activeIndex
    },
    setTs (e) {
      this.ts = e.touches[0].clientX
    },
    shouldGoBack (e) {
      const te = e.changedTouches[0].clientX
      if (this.slide === 0 && te > this.ts) this.$f7router.back()
    },
    reduceAndSort (array, prop) {
      const allProps = array.reduce((dict, info) => {
        if (!dict[info[prop]]) dict[info[prop]] = 1
        else dict[info[prop]]++
        return dict
      }, {})
      const propsArray = Object.keys(allProps).map(prop => {
        return { prop, count: allProps[prop] }
      }).sort((a, b) => b.count - a.count)
      return propsArray[0].prop
    }
  },
  mounted () {
    const station = this.$f7route.params.stationid
    if (station) {
      this.$f7.preloader.show()
      getForecast(station).then(res => {
        this.$f7.preloader.hide()
        this.city = res.name
        const forecast = res.forecast
        const current = Object.assign({ today: true }, this.weather)
        this.forecast = [current, ...forecast]
        this.$nextTick(() => {
          this.$refs.forecastSwiper.swiper.on('slideChange', () => this.getSliderIndex())
          this.$refs.forecastSwiper.swiper.on('touchStart', e => this.setTs(e))
          this.$refs.forecastSwiper.swiper.on('touchEnd', e => this.shouldGoBack(e))
        })
      })
    }
  }
}
</script>

<style lang="scss">
.weather-forecast {
  .city {
    position: absolute;
    z-index: 10;
    top: 0;
    left: 0;
    right: 0;
    color: white;
    text-align: center;
  }
  .weather-forecast-swiper {
    height: 100%;
    position: relative;
    z-index: 1;
  }
  .weather-forecast-slide {
    max-height: 100%;
    overflow: auto;
  }
  .swiper-pagination-bullet-active {
    background-color: white;
  }
}
</style>
